import styled from "styled-components";

export const SectionContainer = styled.div`
  min-height: 100vh;
  margin: 0 auto;
`;
